
export const words = {
  m3: {
    // Drive - Positive
    commanding: 'Comandante', decisive: 'Decisivo', dominant: 'Dominante', assertive: 'Assertivo',
    bold: 'Ousado', direct: 'Direto', ambitious: 'Ambicioso', influential: 'Influente', proactive: 'Proativo',
    // Drive - Negative
    accommodating: 'Acolhedor', cooperative: 'Cooperativo', agreeable: 'Agradável', supportive: 'Apoiador',
    humble: 'Humilde', diplomatic: 'Diplomático', collaborative: 'Colaborativo', gentle: 'Gentil', modest: 'Modesto',
    // Connection - Positive
    sociable: 'Sociável', expressive: 'Expressivo', outgoing: 'Extrovertido', enthusiastic: 'Entusiasmado',
    friendly: 'Amigável', warm: 'Caloroso', engaging: 'Envolvente', charismatic: 'Carismático', animated: 'Animado',
    // Connection - Negative
    reserved: 'Reservado', private: 'Privado', quiet: 'Quieto', reflective: 'Reflexivo',
    solitary: 'Solitário', introverted: 'Introvertido', contemplative: 'Contemplativo', observing: 'Observador', introspective: 'Introspectivo',
    // Task - Positive
    steady: 'Constante', patient: 'Paciente', consistent: 'Consistente', calm: 'Calmo',
    methodical: 'Metódico', reliable: 'Confiável', stable: 'Estável', composed: 'Composto', deliberate: 'Deliberado',
    // Task - Negative
    urgent: 'Urgente', fastPaced: 'Ritmo acelerado', dynamic: 'Dinâmico', impetuous: 'Impetuoso',
    restless: 'Inquieto', quick: 'Rápido', hasty: 'Apressado', impulsive: 'Impulsivo', impatient: 'Impaciente',
    // Order - Positive
    systematic: 'Sistemático', organized: 'Organizado', structured: 'Estruturado', precise: 'Preciso',
    meticulous: 'Meticuloso', detailed: 'Detalhista', accurate: 'Exato', disciplined: 'Disciplinado', thorough: 'Minucioso',
    // Order - Negative
    informal: 'Informal', casual: 'Casual', creative: 'Criativo', relaxed: 'Relaxado',
    easygoing: 'Descontraído', versatile: 'Versátil', flexible: 'Flexível', unconventional: 'Não convencional', unplanned: 'Não planejado',
    // Style - Positive
    analytical: 'Analítico', logical: 'Lógico', dataDriven: 'Orientado por dados', rational: 'Racional',
    objective: 'Objetivo', factual: 'Factual', reasoned: 'Fundamentado', critical: 'Crítico', skeptical: 'Cético',
    // Style - Negative
    intuitive: 'Intuitivo', feelingOriented: 'Orientado por sentimentos', emotional: 'Emocional',
    instinctive: 'Instintivo', empathetic: 'Empático', imaginative: 'Imaginativo',
    compassionate: 'Compassivo', heartfelt: 'Sincero', sentimental: 'Sentimental',
  },
  m2: {
    // Drive
    authoritative: 'Autoritário',
    commanding: 'Comandante',
    forceful: 'Enérgico',
    influential: 'Influente',
    decisive: 'Decisivo',
    assertive: 'Assertivo',
    direct: 'Direto',
    firm: 'Firme',
    strongWilled: 'Determinado',
    confident: 'Confiante',
    ambitious: 'Ambicioso',
    proactive: 'Proativo',
    independent: 'Independente',
    selfAssured: 'Autoconfiante',
    goalOriented: 'Focado em Objetivos',
    // Connection
    expressive: 'Expressivo',
    sociable: 'Sociável',
    enthusiastic: 'Entusiasta',
    vibrant: 'Vibrante',
    animated: 'Animado',
    friendly: 'Amigável',
    warm: 'Caloroso',
    engaging: 'Envolvente',
    personable: 'Pessoal',
    communicative: 'Comunicativo',
    approachable: 'Acessível',
    welcoming: 'Acolhedor',
    interactive: 'Interativo',
    affable: 'Afável',
    gregarious: 'Gregário',
    // Task
    composed: 'Composto',
    tranquil: 'Tranquilo',
    steady: 'Estável',
    unflappable: 'Inabalável',
    poised: 'Equilibrado',
    gentle: 'Gentil',
    balanced: 'Balanceado',
    evenTempered: 'Temperado',
    accommodating: 'Complacente',
    flexible: 'Flexível',
    thoughtful: 'Atencioso',
    considerate: 'Considerado',
    understanding: 'Compreensivo',
    peaceful: 'Pacífico',
    supportive: 'Apoiador',
    // Order
    organized: 'Organizado',
    systematic: 'Sistemático',
    structured: 'Estruturado',
    methodical: 'Metódico',
    rigorous: 'Rigoroso',
    procedural: 'Processual',
    detailed: 'Detalhista',
    thorough: 'Minucioso',
    careful: 'Cuidadoso',
    precise: 'Preciso',
    professional: 'Profissional',
    proper: 'Adequado',
    conventional: 'Convencional',
    traditional: 'Tradicional',
    orderly: 'Ordenado',
    // Style
    dataDriven: 'Orientado por Dados',
    reasoned: 'Racional',
    impartial: 'Imparcial',
    evidenceBased: 'Baseado em Evidências',
    cerebral: 'Cerebral',
    calculated: 'Calculado',
    rationalMinded: 'Mente Racional',
    factFocused: 'Focado em Fatos',
    measured: 'Medido',
    reflective: 'Reflexivo',
    perceptive: 'Perceptivo',
    feelingOriented: 'Orientado por Sentimentos',
    passionate: 'Apaixonado',
    instinctive: 'Instintivo',
    sentimental: 'Sentimental'
  },
  behavioral: {
    dominant: 'Dominante',
    bold: 'Audacioso',
    assertive: 'Assertivo',
    commanding: 'Comandante',
    powerful: 'Poderoso',
    courageous: 'Corajoso',
    daring: 'Ousado',
    determined: 'Determinado',
    competitive: 'Competitivo',
    resolute: 'Resoluto',
    formidable: 'Formidável',
    eager: 'Entusiasmado',
    relentless: 'Implacável',
    outstanding: 'Excepcional',
    dignified: 'Digno',
    social: 'Social',
    engaging: 'Envolvente',
    charismatic: 'Carismático',
    convincing: 'Convincente',
    popular: 'Popular',
    sympathetic: 'Simpático',
    charming: 'Encantador',
    pleasant: 'Ameno',
    talkative: 'Falante',
    esteemed: 'Estimado',
    exciting: 'Empolgante',
    lively: 'Animado',
    appealing: 'Atraente',
    outgoing: 'Extrovertido',
    communicative: 'Comunicativo',
    patient: 'Paciente',
    reasonable: 'Razoável',
    content: 'Satisfeito',
    persistent: 'Persistente',
    relaxed: 'Relaxado',
    serene: 'Sereno',
    tolerant: 'Tolerante',
    consistent: 'Consistente',
    calm: 'Calmo',
    agreeable: 'Agradável',
    stable: 'Estável',
    respectful: 'Respeitoso',
    unobtrusive: 'Discreto',
    easyGoing: 'Descontraído',
    harmonious: 'Harmonioso',
    neat: 'Organizado',
    understanding: 'Compreensivo',
    contemplative: 'Contemplativo',
    conventional: 'Convencional',
    polished: 'Refinado',
    formal: 'Formal',
    precise: 'Preciso',
    accurate: 'Exato',
    factual: 'Factual',
    disciplined: 'Disciplinado',
    orderly: 'Ordenado',
    principled: 'Com Princípios',
    observant: 'Observador',
    meticulous: 'Meticuloso',
    objective: 'Objetivo',
    analytical: 'Analítico',
    logical: 'Lógico',
    systematic: 'Sistemático',
    rational: 'Racional',
    methodical: 'Metódico',
    detached: 'Desapegado',
    realistic: 'Realista',
    pragmatic: 'Pragmático',
    critical: 'Crítico',
    empirical: 'Empírico',
    emotional: 'Emocional',
    intuitive: 'Intuitivo',
    impulsive: 'Impulsivo',
    anxious: 'Ansioso',
    spontaneous: 'Espontâneo',
    // Additional Model 1 words
    cooperative: 'Cooperativo',
    cheerful: 'Alegre',
    generous: 'Generoso',
    passive: 'Passivo',
    quiet: 'Quieto',
    modest: 'Modesto',
    laidBack: 'Descontraído',
    reliable: 'Confiável',
    evenPaced: 'Ritmo constante',
    gracious: 'Gentil',
    reserved: 'Reservado',
    lenient: 'Tolerante',
    perfectionist: 'Perfeccionista',
    tactful: 'Diplomático',
    cautious: 'Cauteloso',
    conscientious: 'Consciencioso',
    diligent: 'Diligente',
    conservative: 'Conservador',
    compliant: 'Obediente',
    thorough: 'Minucioso',
    detailed: 'Detalhista',
    careful: 'Cuidadoso',
    organized: 'Organizado',
    dataDriven: 'Orientado por dados',
    evidenceBased: 'Baseado em evidências',
    rationalMinded: 'Mente racional',
    factFocused: 'Focado em fatos',
    feelingOriented: 'Orientado por sentimentos',
    sentimental: 'Sentimental',
    perceptive: 'Perceptivo',
    reflective: 'Reflexivo',
    calculated: 'Calculado',
    cerebral: 'Cerebral',
    reasoned: 'Racional',
    impartial: 'Imparcial',
    measured: 'Medido',
    passionate: 'Apaixonado',
    instinctive: 'Instintivo',
    accommodating: 'Complacente',
    sociable: 'Sociável',
    friendly: 'Amigável',
    balanced: 'Equilibrado'
  }
};
